/**
 * Copyright (c) 2025, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { ServiceService } from "./service.service";
import { Url_Base } from 'app/rest-constants';
import { RestService } from './rest-service';
import { PagedResults } from "app/models/paged-results";
import { ApiTokenHeader } from "../models/api-token";

/**
 * Service used to interact with the Api Token  backend.
 */
@Injectable()
export class ApiTokenService {

    constructor(
        private serviceService: ServiceService,
        private mRestService: RestService
    ) { }

    /**
     * Returns the base URL for the GTIN Validation Set backend.
     */
    private getUrl(): string {
        return `${Url_Base}/api-tokens/`;
    }

    /**
       * Deletes Api Tokens .
       */

    deleteTokens(ids: number[]): Promise<any> {
        console.log("ids" + ids);
        const callUrl = this.getUrl() + 'delete';
        return this.mRestService.delete(callUrl, ids);
    }



    /**
       * Returns a page of Api Tokens .
       */
    getApiTokenHeaders(start: number, size: number, order: String, filterString: String): Promise<PagedResults<ApiTokenHeader>> {
        const callUrl = `${this.getUrl()}paging?start=${start}&size=${size}&order=ASC&filterColumn=name&filterString=${filterString}`;
        return this.mRestService.get<PagedResults<ApiTokenHeader>>(callUrl);
    }


    public createToken(tokenRequest: ApiTokenHeader): Promise<void> {
        const url = `${this.getUrl()}generate`;
        return this.mRestService.post(url, tokenRequest);
    }



}
